export default __webpack_public_path__ + "static/media/ISLG.26427fba.jpg";